export default __webpack_public_path__ + "static/media/21.fa7d00ca.jpg";